<template>
	<div id="app" style="text-align: left">
		<div class="mars-layout-wrapper">
			<div class="flex flex-top content">
				<ul class="navbar el-menu flex flex-box">
					<div class="afull flex flex-left flex-align-center">
						<div class="flex-box nav-head-logo">
							<img :src="logo" />
							<span style="display:inline-block;height:100%;vertical-align:middle;font-size:0;"></span>
						</div>
						<div class="flex-box nav-head-title">
							<p class="nav-head-title-main-text">
								<span>交费大厅</span>
								<span class="nav-head-title-sub-text">On-line Payment Platform</span>
							</p>
							<span style="display:inline-block;height:100%;vertical-align:middle;font-size:0;"></span>
						</div>
					</div>
				</ul>
				<keep-alive>
					<router-view></router-view>
				</keep-alive>
			</div>
		</div>
	</div>
</template>
<script>
	import logo2 from './../assets/logo2.png'

	export default {
		name: 'layout2',
		data() {
			return {
				logo: logo2
			}
		},
		computed: {
			
		},
		methods: {},
		created() {

		}
	}
</script>
<style lang="css" scoped>
	@import './css/paysuc.css';
</style>
